// Shared token-based relevance search for product lists (client-side)

const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// Word-boundary token match: 'air' matches 'AirPods' but not 'chair'
const tokMatch = (token, text) => new RegExp(`\\b${escapeRegex(token)}`, 'i').test(text);

export const scoreProduct = (p, term, tokens) => {
  const name = (p.name || '').toLowerCase();
  const group = (p.group_name || '').toLowerCase();
  const brand = (p.brand || '').toLowerCase();
  const category = (p.category || '').toLowerCase();
  const barcode = (p.barcode || '').toLowerCase();
  const desc = (p.description || '').toLowerCase();
  const code = (p.product_code || '').toLowerCase();
  const combined = `${name} ${group} ${brand} ${category} ${barcode} ${desc} ${code}`;

  let score = 0;
  if (name === term || code === term) score += 1000;
  if (tokMatch(term, name)) score += 500;
  if (tokMatch(term, group)) score += 250;
  const tokensInName = tokens.filter((t) => tokMatch(t, name)).length;
  if (tokens.length && tokensInName === tokens.length) score += 300;
  score += tokensInName * 40;
  score += tokens.filter((t) => tokMatch(t, group)).length * 25;
  score += tokens.filter((t) => tokMatch(t, barcode)).length * 30;
  score += tokens.filter((t) => tokMatch(t, code)).length * 60;
  score += tokens.filter((t) => tokMatch(t, brand)).length * 20;
  score += tokens.filter((t) => tokMatch(t, category)).length * 10;
  score += tokens.filter((t) => tokMatch(t, desc)).length * 5;
  if ((p.stock || 0) > 0) score += 3;

  const matchedAll = tokens.length > 0 && tokens.every((t) => tokMatch(t, combined));
  return { score, matchedAll };
};

// Returns products matching ALL tokens ranked by relevance;
// if none match all tokens, falls back to the closest (any-token) matches.
export const searchProducts = (products, term) => {
  const q = (term || '').trim().toLowerCase();
  if (!q) return products;
  const tokens = q.split(/\s+/).filter(Boolean);

  const scored = products
    .map((p) => ({ p, ...scoreProduct(p, q, tokens) }))
    .filter((x) => x.score > 3); // must match something beyond stock bonus

  const exact = scored.filter((x) => x.matchedAll);
  const pool = exact.length > 0 ? exact : scored;
  pool.sort((a, b) => b.score - a.score);
  return pool.map((x) => x.p);
};
